export default "__VITE_ASSET__x4MQ5H01__"